import React, { useContext, useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import TableContext from '../TableContext';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';

const useStyles = makeStyles({
  inputRoot: {
    backgroundColor: '#fff',
    '& .MuiInputBase-root': {
      fontSize: '0.875rem'
    },
    '& input': {
      paddingTop: '12px',
      paddingBottom: '12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.1)'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderWidth: '1px'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  }
});

const SearchBox = ({ visible = true, globalSearch = false }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { setQuery, query } = useContext(TableContext);
  if (!visible) {
    return null;
  }

  function onChange(event) {
    if (location.pathname === '/search') {
      const searchParams = new URLSearchParams(location.search);
      if (event.target.value) {
        searchParams.set('search', event.target.value);
        history.push({ search: searchParams.toString() });
      } else {
        history.push({ search: '' });
      }
    }
    setQuery(event.target.value);
  }

  // useEffect(() => {
  //   let searchParams= new URLSearchParams(window.location.search)
  //   // if (searchParams.get("search")) {
  //      setQuery(searchParams.get("search"))
  //   // }
  // }, [])

  return (
    <TextField
      id="table-search"
      placeholder={
        globalSearch
          ? 'Search by Product Name, PIA Number, IFood ID'
          : 'Search...'
      }
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon className={classes.searchIcon} fontSize="small" />
          </InputAdornment>
        )
      }}
      onChange={onChange}
      classes={{ root: classes.inputRoot }}
      style={globalSearch ? { width: '30%' } : {}}
      {...(globalSearch ? { value: query } : '')}
      // value={query || ""}
    />
  );
};

export default SearchBox;
